// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1qTa6","title":"ClientCherryInfo_title__3vpf9","itemText":"ClientCherryInfo_itemText__1n0kv"};